import {Typography} from "@mui/material";
import React from "react";

export const SubHeading = ({title}) => {
  return (<div style={{background:'linear-gradient(90deg, rgba(255,255,255,.05) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.05) 100%)', textTransform: 'uppercase', padding: '5px'}}><Typography variant="h6" color={"primary.light"} sx={{fontSize:'1.1rem'}}>
    {title}
  </Typography></div>)
}